export default __webpack_public_path__ + "static/media/flag-nepal.3606696c.svg";